// 场景1：城管默认场景（完整功能）
export const cgControl = [
    {
        label: 'businessConfig.control.events',
        value: 'events',
        icon: 'el-icon-bell',
        checked: true,
    },
    {
        label: 'businessConfig.control.photos',
        value: 'photos',
        icon: 'el-icon-picture',
        checked: true,
    },
    {
        label: 'businessConfig.control.grid',
        value: 'grid',
        icon: 'el-icon-s-grid',
        checked: true,
    },
    {
        label: 'businessConfig.control.ortho',
        value: 'ortho',
        icon: 'el-icon-camera',
        checked: true,
    },
];

// 场景2：简化场景（仅保留事件和照片）
export const hzControl = [
    {
        label: 'businessConfig.control.riverLakeIslandAndProject',
        value: 'riverLakeIslandAndProject',
        icon: 'el-icon-bell',
        checked: true,
    },
    {
        label: 'businessConfig.control.events',
        value: 'events',
        icon: 'el-icon-bell',
        checked: true,
    },
    {
        label: 'businessConfig.control.photos',
        value: 'photos',
        icon: 'el-icon-picture',
        checked: true,
    },
];
